import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function IsItForYou() {
  const points = ['Mi hijo no me hace caso.', 'Las rabietas me superan.', 'No quiero gritar... pero termino haciéndolo.', 'No sé cómo poner límites sin sentir culpa.', 'Quiero criar diferente a como me criaron.'];
  return <section className="py-16 px-4 md:px-8 max-w-3xl mx-auto" data-id="element-36">
      <div className="text-center mb-10" data-id="element-37">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-textDark mb-4" data-id="element-38">
          ¿Este Mega Pack es para vos?
        </h2>
        <p className="text-xl text-brand-text" data-id="element-39">Sí, si alguna vez pensaste:</p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8" data-id="element-40">
        <ul className="space-y-4" data-id="element-41">
          {points.map((point, index) => <li key={index} className="flex items-center space-x-4 text-lg text-brand-textDark" data-id="element-42">
              <CheckCircle2 className="w-6 h-6 text-brand-sage shrink-0" data-id="element-43" />
              <span className="font-medium" data-id="element-44">"{point}"</span>
            </li>)}
        </ul>
      </div>

      <div className="mt-8 text-center bg-brand-peach/10 p-6 rounded-xl border border-brand-peach/20" data-id="element-45">
        <p className="text-lg text-brand-textDark font-medium" data-id="element-46">
          Si te identificaste con al menos una de estas situaciones, este
          material fue creado para vos.
        </p>
      </div>
    </section>;
}